import React, { useState } from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { appendScriptsCallback, formatDate, formatDateTime } from '../../../helpers/Utils';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getEntityDetails, getPreferredDetails } from '../../../../services/ApiServices';

export function TradingSpendsSetNewPage(): React.ReactElement {
  const [state, setState] = useState<ITradingSpendsSet>({ Id: '', LoadingInfo: {} });
  const currentSecurity = useSecurity('Trading', 'SpendsSet');
  const updatedState: ITradingSpendsSet = { Id: '', LoadingInfo: {} };
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      updatedState.Year = new Date().getFullYear().toString();
      updatedState.CommisionLoaded = 1;
      updatedState.DiscountLoaded = 1;
      setState(updatedState);
      appendScriptsCallback(
        [
          'Areas/Trading/Scripts/Resources/en/res.SpendsSet.en.js',
          'Areas/Trading/Scripts/Resources/en/Types.en.js',
          'Areas/Trading/Scripts/Enums.js',
          'Areas/Trading/Scripts/SpendsSet/View.js',
        ],
        'initNewTradingSpendsSet',
        { viewmodel: updatedState, canEdit: true, canCreate: true, canRemove: true },
      );
    }
  }, []);
  return (
    <div className="container-fluid">
      <section id="patron">
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="SpendsSet" className="controls-container default block">
              <h3>
                Create a New <b>Spends Set</b>
              </h3>
              <p>Please fill in the fields, once completed click on Save to proceed with the creation:</p>
              <form id="form" action="" className="content-view row">
                <div className="col-md-2">
                  <label>Code</label>
                  <input
                    id="SpendsSetCode"
                    max="20"
                    name="Code"
                    type="text"
                    defaultValue={state.Code}
                    className="shortcontrol disabled k-input k-input-solid k-textbox"
                    readOnly
                    disabled
                    placeholder="AUTO-CODE"
                  />
                </div>
                <div className="col-md-2">
                  <label id="SpendsSetLabelBlockedCode">Blocked</label>
                  <input
                    id="SpendsSetCheckBlockedCode"
                    defaultChecked
                    name="SpendsSetCheckBlockedCode"
                    type="checkbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="col-md-4">
                  <label htmlFor="Alias">Alias</label>
                  <input
                    required
                    data-required-msg="Alias is required"
                    id="SpendsSetAlias"
                    name="Alias"
                    type="text"
                    defaultValue={state.Alias}
                    className="k-input k-input-solid k-textbox"
                  />
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="CommisionLoaded" className="required">
                    SAC Loaded
                  </label>
                  <select
                    className=""
                    id="SpendsSetCommisionLoaded"
                    name="CommisionLoaded"
                    value={state.CommisionLoaded}
                    required
                    data-required-msg="SAC Loaded is required"
                  >
                    <option value="0">Yes</option>
                    <option value="1">No</option>
                  </select>
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="DiscountLoaded" className="required">
                    EPD Loaded
                  </label>
                  <select
                    className=""
                    id="SpendsSetDiscountLoaded"
                    name="DiscountLoaded"
                    value={state.DiscountLoaded}
                    required
                    data-required-msg="EPD Loaded is required"
                  >
                    <option value="0">Yes</option>
                    <option value="1">No</option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="Number">Version Number</label>
                  <input
                    required
                    data-required-msg="Version Number is required"
                    data-val-number="The field Version Number must be a number."
                    id="SpendsSetNumber"
                    name="Number"
                    type="text"
                    defaultValue={state.Number}
                    className="k-input k-textbox"
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="Year">Year</label>
                  <input
                    required
                    data-required-msg="Year is required"
                    data-val-number="The field Year must be a number."
                    id="SpendsSetYear"
                    name="Year"
                    type="text"
                    defaultValue={state.Year}
                    className="k-input k-textbox"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="SourceReference">Source Reference</label>
                  <input
                    id="SpendsSetSourceReference"
                    max="60"
                    name="SourceReference"
                    type="text"
                    defaultValue={state.SourceReference}
                    className="shortcontrol k-input k-input-solid k-textbox"
                    placeholder="SOURCE-REFERENCE"
                  />
                </div>
              </form>
              <section className="button-toolbar" id="ToolbarSpendsSet">
                <div className="left">
                  <button id="cancelSpendsSetButton" type="button" className="k-button button" title="Cancel">
                    Cancel
                  </button>
                </div>
                <div className="right">
                  <button id="saveSpendsSetButton" type="button" className="k-button button" title="Save">
                    Save
                  </button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}

interface ITradingSpendsSet {
  LoadingInfo: {
    CreationDate?: string;
    CreatedBy?: string;
    CreatedByDisplayValue?: string;
    UpdateDate?: string;
    UpdatedBy?: string;
    UpdatedByDisplayValue?: string;
    SourceStatus?: number;
    Source?: number;
  };
  Alias?: string;
  CommisionLoaded?: number;
  DiscountLoaded?: number;
  Number?: number;
  Year?: string;
  Code?: string;
  Display?: string;
  EntityStatus?: number;
  SourceReference?: string;
  Id: string;
  InactiveFrom?: Date;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum ApplianceModeEnum {
  'Yes' = 0,
  'No' = 1,
}

export function TradingSpendsSetDetailPage(): React.ReactElement {
  const { id } = useParams();
  const [state, setState] = useState<ITradingSpendsSet>({ Id: '', LoadingInfo: {} });
  const currentSecurity = useSecurity('Trading', 'SpendsSet');
  React.useEffect(() => {
    if (state.Id == '' && currentSecurity.checkAccess()) {
      getEntityDetails('Trading', 'SpendsSet', id).then((result) => {
        setState(result.Value[0] as ITradingSpendsSet);
        appendScriptsCallback(
          [
            'Areas/Trading/Scripts/Resources/en/res.SpendsSet.en.js',
            'Areas/Trading/Scripts/Resources/en/Types.en.js',
            'Areas/Trading/Scripts/Enums.js',
            'Areas/Trading/Scripts/SpendsSet/View.js',
          ],
          'initDetailTradingSpendsSet',
          { viewmodel: result.Value[0], canEdit: true, canCreate: true, canRemove: true, id: id },
        );
      });
    }
  }, []);
  window['reloadTradingSpendsSetState'] = (data) => {
    setState(data.Value[0] as ITradingSpendsSet);
  };
  return (
    <div className="container-fluid">
      <section id="patron" style={{ display: 'none' }}>
        <section className="content">
          <div className="clear"></div>
          <section id="viewContent">
            <div id="SpendsSet" className="controls-container default block">
              <div className="content-label">
                <div className="content-title">
                  <div className="k-content">
                    <h3>
                      Spends Set: <span>{state.Display}</span>
                      <span
                        id="SpendsSetToggle"
                        className="k-icon k-i-media-manager"
                        style={{ cursor: 'pointer' }}
                      ></span>
                    </h3>
                  </div>
                </div>
                <div className="content-line">
                  <span className="element">
                    <label>
                      SAC Loaded:{' '}
                      <label className="strong">
                        {state.CommisionLoaded != undefined ? ApplianceModeEnum[state.CommisionLoaded] : ''}
                      </label>
                    </label>
                  </span>
                  <span className="element">
                    <label>
                      EPD Loaded:{' '}
                      <label className="strong">
                        {state.DiscountLoaded != undefined ? ApplianceModeEnum[state.DiscountLoaded] : ''}
                      </label>
                    </label>
                  </span>
                  <span className="element">
                    <label>
                      Version Number: <label className="strong">{state.Number}</label>
                    </label>
                  </span>
                </div>
                <div className="content-line">
                  <span className="element">
                    <label>
                      Year: <label className="strong">{state.Year}</label>
                    </label>
                  </span>
                </div>
              </div>
              <form id="form" action="" style={{ display: 'none' }} className="content-view row">
                <div className="col-md-2">
                  <label>Code</label>
                  <input
                    id="SpendsSetCode"
                    max="20"
                    name="Code"
                    type="text"
                    defaultValue={state.Code}
                    className="shortcontrol disabled k-input k-input-solid k-textbox"
                    readOnly
                    disabled
                    placeholder="AUTO-CODE"
                  />
                </div>
                <div className="col-md-2">
                  <label id="SpendsSetLabelBlockedCode">Blocked</label>
                  <input
                    id="SpendsSetCheckBlockedCode"
                    defaultChecked
                    name="SpendsSetCheckBlockedCode"
                    type="checkbox"
                  />
                </div>
                <div className="clear"></div>
                <div className="col-md-4">
                  <label htmlFor="Alias">Alias</label>
                  <input
                    required
                    data-required-msg="Alias is required"
                    id="SpendsSetAlias"
                    name="Alias"
                    type="text"
                    defaultValue={state.Alias}
                    className="k-input k-input-solid k-textbox"
                  />
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="CommisionLoaded" className="required">
                    SAC Loaded
                  </label>
                  <select
                    className=""
                    id="SpendsSetCommisionLoaded"
                    name="CommisionLoaded"
                    value={state.CommisionLoaded}
                    required
                    data-required-msg="SAC Loaded is required"
                  >
                    <option value="0">Yes</option>
                    <option value="1">No</option>
                  </select>
                </div>
                <div className="col-md-2 dropdownlist  ">
                  <label htmlFor="DiscountLoaded" className="required">
                    EPD Loaded
                  </label>
                  <select
                    className=""
                    id="SpendsSetDiscountLoaded"
                    name="DiscountLoaded"
                    value={state.DiscountLoaded}
                    required
                    data-required-msg="EPD Loaded is required"
                  >
                    <option value="0">Yes</option>
                    <option value="1">No</option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="Number">Version Number</label>
                  <input
                    required
                    data-required-msg="Version Number is required"
                    data-val-number="The field Version Number must be a number."
                    id="SpendsSetNumber"
                    name="Number"
                    type="text"
                    defaultValue={state.Number}
                    className="k-input k-textbox"
                  />
                </div>
                <div className="col-md-2">
                  <label htmlFor="Year">Year</label>
                  <input
                    required
                    data-required-msg="Year is required"
                    data-val-number="The field Year must be a number."
                    id="SpendsSetYear"
                    name="Year"
                    type="text"
                    defaultValue={state.Year}
                    className="k-input k-textbox"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="SourceReference">Source Reference</label>
                  <input
                    id="SpendsSetSourceReference"
                    max="60"
                    name="SourceReference"
                    type="text"
                    defaultValue={state.SourceReference}
                    className="shortcontrol k-input k-input-solid k-textbox"
                    placeholder="SOURCE-REFERENCE"
                  />
                </div>
                <div className="clear"></div>
                <div className="content-header">Tracking</div>
                <div className="col-md-4">
                  <label htmlFor="LoadingInfo_SourceStatus">Loading Status</label>
                  <select
                    className=""
                    id="SpendsSetSourceStatus"
                    name="LoadingInfo.SourceStatus"
                    value={state.LoadingInfo.SourceStatus}
                  >
                    <option value="0">Loaded</option>
                    <option value="1">Processed</option>
                    <option value="2">Pending</option>
                    <option value="3">Reloaded</option>
                    <option value="4">Error</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="LoadingInfo_Source">Source</label>
                  <select className="" id="SpendsSetSource" name="LoadingInfo.Source" value={state.LoadingInfo.Source}>
                    <option value="0">Owned</option>
                    <option value="1">ExternalPlanning</option>
                    <option value="2">ExternalBuying</option>
                    <option value="3">ExternalFinance</option>
                    <option value="4">ExternalHub</option>
                  </select>
                </div>
                <div className="clear"></div>
                <div className="trackinfo">
                  <div className="line">
                    Created on <span className="when">{formatDateTime(state.LoadingInfo.CreationDate)}</span> by{' '}
                    <span className="who">{state.LoadingInfo.CreatedByDisplayValue}</span>{' '}
                  </div>
                  <div className="line">
                    Last Update on <span className="when">{formatDateTime(state.LoadingInfo.UpdateDate)}</span> by{' '}
                    <span className="who">{state.LoadingInfo.UpdatedByDisplayValue}</span>{' '}
                  </div>
                </div>
              </form>
              <section className="button-toolbar" style={{ display: 'none' }} id="ToolbarSpendsSet">
                <div className="left">
                  <button id="cancelSpendsSetButton" type="button" className="k-button button" title="Cancel">
                    Cancel
                  </button>
                </div>
                <div className="right">
                  <button id="saveSpendsSetButton" type="button" className="k-button button" title="Save">
                    Save
                  </button>
                </div>
              </section>
            </div>
          </section>
        </section>
      </section>
    </div>
  );
}
